import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import colors from '../../../styled/colors';
import mediaQueries from '../../../utils/mediaQueries';

const Section = styled.section`
  background: ${colors.screenBackground};
  padding: 36px 24px 22px 18px;
  @media ${mediaQueries.mdUp} {
    padding: 28px 24px 28px 18px;
  }
  @media ${mediaQueries.lgPlusUp} {
    padding: 34px 38px;
  }
  @media ${mediaQueries.xlPlusUp} {
    padding: 54px 102px 42px;
  }
`;
const Container = styled.div`
  color: ${colors.pink};
  font-size: 14px;
  font-style: italic;
  text-align: center;
  @media ${mediaQueries.mdUp} {
    font-size: 15px;
  }
`;
const Text = styled.q`
  line-height: 24px;
  @media ${mediaQueries.mdUp} {
    line-height: 26px;
  }
  @media ${mediaQueries.lgPlusUp} {
    font-size: 18px;
    line-height: 32px;
  }
  @media ${mediaQueries.xlPlusUp} {
    font-size: 24px;
    line-height: 32px;
  }
`;
const Source = styled.span`
  cursor: pointer;
  display: block;
  width: 100%;
  text-decoration: underline;
  margin-top: 26px;
  @media ${mediaQueries.mdUp} {
    margin-top: 20px;
  }
  @media ${mediaQueries.lgPlusUp} {
    font-size: 16px;
  }
  @media ${mediaQueries.xlPlusUp} {
    font-size: 18px;
  }
`;

const Quote = () => {
  const articleURL = 'https://blog.digimind.com/es/insight-driven-marketing/instagram-cifras-imprescindibles-2021';
  const goToArticle = () => {
    window.open(articleURL, '_blank', 'noopener, noreferrer');
  };
  return (
    <Section>
      <Container>
        <Text>
          <FormattedMessage
            id="landing.instagram.quote.text"
            defaultMessage="Instagram helps 80% of consumers to make a decision of purchase a product or service. (...)In one year (2017-2018), there was a + 80% increase in video consuming."
          />
        </Text>
        <Source onClick={goToArticle}>
          <FormattedMessage
            id="landing.instagram.quote.source"
            defaultMessage="Digimind, 2019"
          />
        </Source>
      </Container>
    </Section>
  );
};

export default Quote;
